import { gql } from '@apollo/client';
import {
    META_PAGE_FILTER_FRAGMENT,
    META_PAGE_TOTAL_FRAGMENT,
} from 'apollo/metaPage/metaPage.fragment';
import { SAMPLE_FRAGMENT } from 'apollo/sample/sample.fragment';
import { PACK_EXCERPT_FRAGMENT } from 'apollo/pack/pack.fragment';
import {
    LABEL_DETAIL_FRAGMENT,
    LABEL_EXCERPT_FRAGMENT,
} from './label.fragment';

export const PaginatedLabels = gql`
    query PaginatedLabels(
        $take: Int
        $page: Int
        $query: String
        $offset: Int
    ) {
        paginatedLabels(
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                ...LabelExcerptFragment
            }
            meta {
                totalRecords
                totalPackRecords
            }
            next {
                skip
            }
        }
    }
    ${LABEL_EXCERPT_FRAGMENT}
`;

export const PaginatedLabelSamples = gql`
    query PaginatedLabelSamples(
        $labelGuid: ID
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedLabelSamples(
            labelGuid: $labelGuid
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                ...SampleFragment
            }
            meta {
                ...MetaPageTotalFragment
                ...MetaPageFilterFragment
            }
            next {
                skip
            }
        }
    }
    ${META_PAGE_FILTER_FRAGMENT}
    ${META_PAGE_TOTAL_FRAGMENT}
    ${SAMPLE_FRAGMENT}
`;

export const PaginatedLabelPacks = gql`
    query PaginatedLabelPacks(
        $labelGuid: ID
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedLabelPacks(
            labelGuid: $labelGuid
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                ...PackExcerptFragment
            }
            meta {
                ...MetaPageTotalFragment
                ...MetaPageFilterFragment
            }
            next {
                skip
            }
        }
    }
    ${META_PAGE_FILTER_FRAGMENT}
    ${META_PAGE_TOTAL_FRAGMENT}
    ${PACK_EXCERPT_FRAGMENT}
`;

export const LabelBySlug = gql`
    query LabelBySlug($slug: String) {
        labelBySlug(slug: $slug) {
            ...LabelDetailFragment
        }
    }
    ${LABEL_DETAIL_FRAGMENT}
`;
